<template>
	<div>
		<field-name-slug v-model="field"></field-name-slug>

		<field-placeholder v-model="field"></field-placeholder>

		<slot></slot>

		<validation v-model="field"></validation>
	</div>
</template>

<script>

import FieldNameSlug from './reusables/FieldNameSlug';
import Validation from './reusables/Validation';
import FieldPlaceholder from './reusables/FieldPlaceholder';

export default {

	props: {
		value: {
			type: Object,
			required: true,
		},
	},

	data() {
		return {
			field: this.value,
		};
	},

	watch: {

		field: {
			deep: true,
			handler(value) {
				this.$emit('input', value);
			}
		},
	},

	components: {
		FieldNameSlug,
		Validation,
		FieldPlaceholder,
	},

};

</script>
